import { ArrowForward } from '@mui/icons-material';
import { Box, Button, Radio, Tooltip } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Board, getActiveBoardsByCompanyId } from '../../../services/requests';

import useAuthStore from '../../../store/auth';
import useCompanyStore from '../../../store/companies';

import { Card, Div, Info, Title, Text, MembersLength } from './styles';

interface StepBoardProps {
  handleNext: () => void;
  setSelectedBoardId: (boardId: string) => void;
  selectedBoardId: string;
}

export const StepBoard = ({
  handleNext,
  setSelectedBoardId,
  selectedBoardId,
}: StepBoardProps) => {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [listagemBoards, setListagemBoards] = useState<Board[]>([]);

  async function loadBoards() {
    const response = await getActiveBoardsByCompanyId(
      selectedCompany?.id as string,
      '',
      user?.id as string,
    );

    setListagemBoards(response?.data);
  }

  useEffect(() => {
    if (selectedCompany) {
      loadBoards();
    }
  }, [user, selectedCompany]);

  const handleBoardsSelecteds = useCallback(() => {
    if (selectedBoardId) {
      handleNext();
    } else {
      toast.warn('Você deve selecionar um Board para prosseguir');
    }
  }, [handleNext, selectedBoardId]);

  const getLabelForAmountMembers = (amountMembers: number) => {
    if (amountMembers === 1) {
      return `${amountMembers} membro`;
    }
    return `${amountMembers} membros`;
  };

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Box height="100%" display="flex" flexDirection="column">
        <Text>Escolha um board para criar a reunião</Text>
        {listagemBoards?.length > 0 ? (
          <Div>
            {listagemBoards?.map(b => (
              <Tooltip
                title={
                  b?.members?.find(u => u?.id === user?.id)?.profile === 'BMS1'
                    ? null
                    : 'Você não tem permissão para criar uma reunião com este Board.'
                }
                key={b?.id}
              >
                <Card
                  onClick={() => setSelectedBoardId(b.id)}
                  sx={{
                    borderColor: b.color,
                    backgroundColor:
                      b?.members?.find(u => u?.id === user?.id)?.profile ===
                      'BMS1'
                        ? '#f5f5f5'
                        : '#bdbdbd',
                    cursor:
                      b?.members?.find(u => u?.id === user?.id)?.profile ===
                      'BMS1'
                        ? 'default'
                        : 'not-allowed',
                    padding:
                      b?.members?.find(u => u?.id === user?.id)?.profile ===
                      'BMS1'
                        ? '0'
                        : '10px',
                  }}
                >
                  {b?.members?.find(u => u?.id === user?.id)?.profile ===
                    'BMS1' && (
                    <Radio
                      checked={selectedBoardId === b.id}
                      value={b.id}
                      onChange={() => setSelectedBoardId(b.id)}
                    />
                  )}
                  <Info display="flex" flexDirection="column">
                    <Tooltip
                      title={
                        b?.members?.find(u => u?.id === user?.id)?.profile ===
                          'BMS1' && b.title
                      }
                      arrow
                    >
                      <Box display="flex" width="75%">
                        <Title>{b.title}</Title>
                      </Box>
                    </Tooltip>
                    <MembersLength>
                      {getLabelForAmountMembers(b?.members?.length as number)}
                    </MembersLength>
                  </Info>
                </Card>
              </Tooltip>
            ))}
          </Div>
        ) : (
          <Box>Esta empresa não possui boards adicionados.</Box>
        )}
      </Box>
      <Box
        display="flex"
        width="100%"
        justifyContent="end"
        flex="0 0 0"
        marginTop="20px"
      >
        <Button
          onClick={handleBoardsSelecteds}
          variant="contained"
          color="success"
          sx={{
            color: '#ffffff',
            fontSize: '15px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            height: '42px',
          }}
        >
          Continuar <ArrowForward />
        </Button>
      </Box>
    </Box>
  );
};
